









const jQuery = require("jquery");
window.$ = window.jQuery = jQuery;

require("bootstrap");
require("jquery.easing");
require("magnific-popup");

require("../src/assets/js/freelancer.js");

import { Component, Vue } from "vue-property-decorator";
import Home from "@/views/Home.vue";

@Component({
  components: {
    Home
  }
})
export default class App extends Vue {}
